import Vue from 'vue'
import Toast from '_c/toast/Toast'

const getComponent = function (title, delay = 1000) {
  const instance = new Vue({
    render (h) {
      return h(Toast, {
        props: {
          title,
          delay
        }
      })
    }
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  return instance.$children[0]
}
export const showToast = function (title, delay) {
  return getComponent(title, delay)
}
